import React from 'react';
import './product-badge.scss';

export const HeroBadge = ({ value }) => <span className="product-badge__hero">{value}</span>;
export const HeroBadgeContainer = ({ badge }) => {
  const { value } = badge;

  return (
    badge &&
    value && (
      <div className="product-badge__hero-container">
        <HeroBadge value={value} />
      </div>
    )
  );
};

export const PromoBadge = ({ value }) => <span className="product-badge__promo">{value}</span>;
export const PromoBadgeContainer = ({ badge }) => {
  const { value, description } = badge;

  return (
    badge &&
    value && (
      <div className="product-badge__promo-container">
        <PromoBadge value={value} />
        {description && <span className="product-badge__promo-description">{description}</span>}
      </div>
    )
  );
};
